import { useEffect, useState } from "react";
import { Wallet } from "lucide-react";
import api from "@/lib/api";

// Live "Balance: $X.XX" readout for everyone, plus this video's "Creation Amount" (its metered
// cost) to the LEFT — e.g. "Creation Amount $1.38 / Balance $47.88". Shown to all signed-in members.
export const SpendTicker = ({ className = "", manualId = null }) => {
  const [me, setMe] = useState(null);
  const [spend, setSpend] = useState(null);

  const load = () => {
    api.get(`/auth/me`).then(({ data }) => {
      setMe(data);
      // Creation Amount is ADMIN-ONLY — members should never see per-video cost (avoids "TMI").
      if (data?.unlimited && manualId) {
        api.get(`/me/ai-spend?manual_id=${encodeURIComponent(manualId)}`)
          .then(({ data: s }) => setSpend(s))
          .catch(() => {});
      } else {
        setSpend(null);
      }
    }).catch(() => {});
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 5000);
    return () => clearInterval(iv);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manualId]);

  if (!me) return null;

  const unlimited = !!me.unlimited;
  const amount = unlimited ? "Unlimited" : `$${Number(me.balance_usd ?? 0).toFixed(2)}`;

  return (
    <div
      data-testid="balance-ticker"
      className={`inline-flex items-center gap-2 rounded-full bg-[#f0f6ec] border border-[#cfe0c7] px-3 py-1.5 text-xs font-bold text-[#4f7746] ${className}`}
      title={unlimited ? "Admin — unlimited account" : "Your account balance"}
    >
      <Wallet size={13} className="text-[#5d8a52]" />
      {unlimited && spend && spend.ops > 0 && (
        <>
          <span data-testid="creation-amount">Creation Amount <span className="text-[#171426]">${Number(spend.cost).toFixed(2)}</span></span>
          <span className="text-[#9cbf90]">/</span>
        </>
      )}
      Balance: <span className="text-[#171426]">{amount}</span>
    </div>
  );
};

export default SpendTicker;
